import { render, staticRenderFns } from "./verification-required.vue?vue&type=template&id=210aee50&scoped=true&"
import script from "./verification-required.vue?vue&type=script&lang=js&"
export * from "./verification-required.vue?vue&type=script&lang=js&"
import style0 from "./verification-required.vue?vue&type=style&index=0&id=210aee50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210aee50",
  null
  
)

export default component.exports